import { ADD_NEW_RTO, ADD_NEW_RTO_ERROR, ADD_NEW_RTO_SUCCESS } from "./Constants";

const initialState = {
    Loading: false,
    successMsg: "",
    errors: ""
}

const ManageRtoReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_NEW_RTO:
            return {
                ...state,
                Loading: true,
                successMsg: "",
                errors: ""
            }
        case ADD_NEW_RTO_SUCCESS: return {
            ...state,
            Loading: false,
            successMsg: action.payload
        }
        case ADD_NEW_RTO_ERROR:
            return {
                ...state,
                Loading: false,
                errors: action.payload
            }

        default:
            return state

    }
}

export default ManageRtoReducer